module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIUlEQVR4AWMYNOA/Ov5z1xEFf9Ewx8CDxIBRA0YNGB4AAJOqPsMncnUCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BE.png
// module id = 1087
// module chunks = 0